import React, { Component } from 'react'
import Catch from './Catch'
import Companies from './Companies'
import About from './About'
import Benefit from './Benefit'
import Features from './Features'
import Timetable from './Timetable'
import Overview from './Overview'
import Entry from './Entry'
import StickyButton from './StickyButton'

class Grad21 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      grad_year: 21,
      id: new URLSearchParams(this.props.location.search).get('id'),
      show_sticky_button: true,
      content_height: null,
    } 
  }

  componentDidMount() {
    this.setState({ content_height: document.getElementById('root').offsetHeight })
    window.addEventListener('scroll', event => this.watchCurrentPosition(), true)    
  }

  watchCurrentPosition() {
    if (this.top() > this.state.content_height - 200) {
      this.setState({ show_sticky_button: false})
    } else {
      this.setState({ show_sticky_button: true})      
    }
  }

  top() {
    return Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop);
  }  

  render() {
    return (
      <div className="grad21">
        <Catch grad_year={this.state.grad_year} id={this.state.id} />
        <Companies />
        <About />
        <Benefit />
        <Features grad_year={this.state.grad_year} />
        <Timetable />
        <Overview grad_year={this.state.grad_year} />
        <Entry id={this.state.id} />
        <StickyButton id={this.state.id} show={this.state.show_sticky_button} />
      </div>
    )
  }
}

export default Grad21